import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgProjectSelection = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M17 12C17 13.3538 16.1033 14.4981 14.8715 14.8715C14.955 14.5957 15 14.3031 15 14V6C15 4.34315 13.6569 3 12 3H4C3.69691 3 3.40433 3.04495 3.12854 3.12854C3.5019 1.89669 4.64623 1 6 1H14C15.6569 1 17 2.34315 17 4V12Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12 3H4C3.69691 3 3.40433 3.04495 3.12854 3.12854C1.89669 3.5019 1 4.64623 1 6V14C1 15.6569 2.34315 17 4 17H12C13.3538 17 14.4981 16.1033 14.8715 14.8715C14.955 14.5957 15 14.3031 15 14V6C15 4.34315 13.6569 3 12 3Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4 9.8L6.66667 12.6L12 7M14.8715 14.8715C14.4981 16.1033 13.3538 17 12 17H4C2.34315 17 1 15.6569 1 14V6C1 4.64623 1.89669 3.5019 3.12854 3.12854M14.8715 14.8715C16.1033 14.4981 17 13.3538 17 12V4C17 2.34315 15.6569 1 14 1H6C4.64623 1 3.5019 1.89669 3.12854 3.12854M14.8715 14.8715C14.955 14.5957 15 14.3031 15 14V6C15 4.34315 13.6569 3 12 3H4C3.69691 3 3.40433 3.04495 3.12854 3.12854",
			stroke: "white",
			strokeLinecap: "round"
		})
	]
});
export default SvgProjectSelection;
